<template>
  <div v-if="active" class="qr-reader-overlay">
    <div class="qr-reader-popup">
      <div id="qr-reader" style="width: 350px"></div>
      <p>Scan QR Code</p>
      <p>{{ result }}</p>
      <button @click="closeScanner">Schließen</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { Html5Qrcode } from 'html5-qrcode'
import { useUIStore } from '../stores/ui'
import router from '@/router'

const active = ref(true)
const result = ref('')
let scanner: Html5Qrcode | null = null

function closeScanner() {
  active.value = false
  useUIStore().closeQrScanner()
  scanner?.stop().then(() => scanner?.clear())
}

onMounted(() => {
  const config = { fps: 10, qrbox: 250 }
  scanner = new Html5Qrcode('qr-reader')
  scanner
    .start(
      { facingMode: 'environment' },
      config,
      (decodedText) => {
        result.value = decodedText
        // Optional: Weiterleitung oder Verarbeitung
        console.log(`QR Code detected: ${decodedText}`)
        router.push(`/info/${decodedText}`)
        setTimeout(() => {
          closeScanner()
        }, 660)
      },
      (errorMessage) => {
        // handle scan error
        console.warn(`QR Code scan error: ${errorMessage}`)
      },
    )
    .catch((err) => {
      console.error(`Unable to start scanning, error: ${err}`)
    })
})
</script>

<style scoped>
.qr-reader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
}
.qr-reader-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--bg-elevated);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
}
.qr-reader-popup button {
  padding: 10px 20px;
  background-color: var(--brand-secondary);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
